export enum Expansion {
    ARR = "ARR",
    HW = "HW",
    SB = "SB",
    ShB = "ShB",
    EW = "EW",
    DT = "DT",
}